import { FormItemsGroup, Spacing, Tag } from '@billy/design-system'
import isEmpty from 'lodash/isEmpty'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoiceEditorForm } from '../../../../../../contexts/invoiceEditorFormContext'
import { ExpandableSection } from '../ExpandableSection'
import { InvoiceBuyerReference } from './elements/InvoiceBuyerReference'
import { InvoicePurchaseOrderNumber } from './elements/InvoicePurchaseOrderNumber'

export const InvoiceClientReferences = (): ReactElement => {
  const { t } = useTranslation()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()

  const { watch } = invoiceEditorForm
  const [buyerReference, purchaseOrderNumber] = watch(['buyerReference', 'purchaseOrderNumber'])

  const hasAnyClientReferenceValue = !isEmpty(buyerReference) || !isEmpty(purchaseOrderNumber)

  const handleToggle = useCallback(
    (isSectionExpanded: boolean) => {
      trackInvoiceEditor(`Client references ${isSectionExpanded ? 'expanded' : 'collapsed'}`)
    },
    [trackInvoiceEditor],
  )

  const collapsedTags = (
    <>
      {purchaseOrderNumber && (
        <Tag size="sm" type="subtle">
          {purchaseOrderNumber}
        </Tag>
      )}
      {buyerReference && (
        <Tag size="sm" type="subtle">
          {buyerReference}
        </Tag>
      )}
    </>
  )

  return (
    <ExpandableSection
      collapsedTags={collapsedTags}
      emptyLabel={t('external_invoices.editor.form.field.invoice_client_references.toggle.add.label')}
      hasValue={hasAnyClientReferenceValue}
      onToggle={handleToggle}
      toggleLabel={t('external_invoices.editor.form.field.invoice_client_references.toggle.label')}
    >
      <FormItemsGroup itemsInRow={2} columnSpacing={Spacing.S16}>
        <InvoicePurchaseOrderNumber />
        <InvoiceBuyerReference />
      </FormItemsGroup>
    </ExpandableSection>
  )
}
